// src/data/directors.js
const DIRECTORS = [
  {
    slug: "harkeshwar-yadav",
    name: "Mr. Harkeshwar Yadav",
    designation: "Co-Founder & Managing Director – Operations & QHSES",
    story:
      "20+ years of experience in engineering, industrial operations, research, and entrepreneurship with expertise in power systems, HVAC, and industrial automation.",
    vision:
      "Driving innovation and sustainable growth through engineering excellence and operational leadership.",
    src: "/assets/HarkeshwarYadav.jpg",
    bio: `Mr. Harkeshwar Yadav is the Co-Founder and Managing Director – Operations, bringing with him
over two decades of multidisciplinary experience spanning engineering, industrial operations,
applied research, and entrepreneurship. He holds an M.Tech in Engineering Systems and a
B.Tech in Electrical Engineering, combining strong academic foundations with extensive handson industry expertise.
Throughout his professional journey, he has contributed significantly to both applied engineering
environments and academic institutions, successfully bridging the gap between theoretical
understanding and practical implementation. His work reflects a deep commitment to innovation,
operational efficiency, and sustainable development across diverse industrial sectors.
His core technical interests lie at the intersection of thermal management, power electronics, and
electrical power systems, where he continues to drive research-oriented thinking, problemsolving, and process optimization. Over the years, he has developed substantial hands-on
expertise in HVAC systems, thermal and acoustic insulation solutions, industrial automation, and
industrial supply chain operations.
In addition to his engineering and operational leadership, Mr. Yadav has actively worked in the
fields of agro-ecological development and precision farming, integrating technology-driven
approaches with sustainable agricultural practices.
An entrepreneur at heart, he has spent the last six years building and managing multiple business
ventures with strategic vision and operational discipline. His entrepreneurial mindset, coupled with
strong technical acumen and leadership capabilities, continues to play a pivotal role in driving
organizational growth, innovation, and long-term value creation.`
  },
  {
    slug: "niketa-goyal",
    name: "Ms. Niketa Goyal",
    designation: "Director – Process, Compliance, Marketing & Human Resources",
    story:
      "Experienced educator and entrepreneur with expertise in operations, compliance, communication, and organisational development, driving efficiency and brand growth.",
    vision:
      "To build sustainable growth through strong systems, ethical practices, and meaningful stakeholder relationships.",
    src: "/assets/NiketaGoyal.jpg",
    bio: `Ms. Niketa Goyal is a seasoned educator and emerging entrepreneur with over a decade of
experience in leadership, communication, and organisational development. With a strong
academic foundation in senior secondary education, she has built her professional journey on
discipline, structured thinking, and impactful communication, strengths that seamlessly translate
into her business leadership.
Her extensive experience in managing large and diverse academic environments has honed her
ability to drive operational efficiency, uphold high standards, and implement well-defined systems.
Known for her precision, attention to detail, and process-driven approach, she brings clarity and
consistency to process management and compliance functions.
As Director, she combines structure with strategic creativity. She plays a key role in streamlining
operations, ensuring robust compliance frameworks, and strengthening the organisation’s brand
through clear, purposeful communication. Her strong command over audience engagement
further enhances the company’s marketing direction and positioning.
Recognised for her disciplined work ethic and solution-oriented mindset, she believes sustainable
growth is rooted in strong systems, ethical practices, and meaningful stakeholder relationships.
Her leadership is defined by a commitment to operational excellence, continuous improvement,
and long-term value creation.
For her, leadership is anchored in trust, integrity, and the constant pursuit of progress, driving
both people and organisations toward enduring success.`
  },
  {
    slug: "radha-karanwal",
    name: "Mrs. Radha Karanwal",
    designation: "Director – Commercial Operations & Sustainability",
    story:
      "Experienced leader and entrepreneur with expertise in commercial operations, purchasing, people management, and strategic business growth.",
    vision:
      "To drive sustainable growth through operational excellence, innovation, and people-centric leadership.",
    src: "/assets/RadhaKaranwal.jpg",
    bio: `Radha Karnwal, Director of Commercial Operations, is a distinguished professional,
visionary entrepreneur, and inspiring leader whose career reflects resilience, versatility,
and an unwavering commitment to excellence. Holding a postgraduate degree (M.A.) in
English, she brings strong communication skills, strategic clarity, and intellectual depth to
every role she undertakes.
Her professional journey began in the education sector, where she developed a solid
foundation in leadership, organization, and people management while shaping minds
through knowledge. This experience seamlessly transitioned into the commercial and
purchasing domain, where she demonstrated exceptional operational expertise, sound
business judgment, and the ability to manage complex responsibilities with precision and
efficiency.
What truly sets Radha apart is her entrepreneurial spirit, driven by ambition, adaptability,
and the courage to transform experience into enterprise. Her journey as an entrepreneur
reflects her capacity to identify opportunities, embrace change, and contribute
meaningfully to business growth and operational success through innovation and
perseverance.
As Director of Commercial Operations, Radha combines strategic vision with commercial
acumen and people-centric leadership to drive efficiency, growth, and sustainable value.
Her empowering leadership style, commitment to operational integrity, and forwardthinking mindset make her a cornerstone of organizational success and an inspiring
example of modern, impactful leadership.`,
  },
];

export default DIRECTORS;
